import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPost } from 'api-service';
import { getContentPayload } from 'store/content/contentHelpers';
import { summarizerAdapter } from './aiSummarizer.adapters';

export const fetchAISummary = createAsyncThunk(
  'aiSummarizerReducer/fetchAISummery',
  async ({ platform, api_path, bulletin_id }, thunkAPI) => {
    const payload = bulletin_id
      ? { api_path, bulletin_id }
      : getContentPayload(platform, thunkAPI);

    try {
      const response = await apiPost('/search/api/v3/aia/summarize', {
        ...payload,
      });
      return summarizerAdapter(
        response?.data?.result?.data,
        response?.data?.result?.meta
      );
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchAISummaryArchive = createAsyncThunk(
  'aiSummarizerReducer/fetchAISummaryArchive',
  async (summaryId, thunkAPI) => {
    try {
      const response = await apiGet(
        `/search/api/v3/aia/summarize/${summaryId}`
      );
      return summarizerAdapter(response?.data?.result?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchAISummaryArchives = createAsyncThunk(
  'aiSummarizerReducer/fetchAISummaryArchives',
  async (params, thunkAPI) => {
    try {
      const response = await apiGet('/search/api/v3/aia/summarize', {
        ...params,
      });

      const finalData = response?.data?.result?.data?.map((item) =>
        summarizerAdapter(item)
      );
      const remaining =
        response?.data?.result?.meta?.limit -
        response?.data?.result?.meta?.attempts;
      return {
        data: finalData,
        totalItemsCount: response?.data?.result?.meta?.total,
        remainingLimit: remaining > 0 ? remaining : 0,
        limit: response?.data?.result?.meta?.limit,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
